import React, { useMemo } from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import { useTranslation } from "@awe-web/shared/lib";

import {ScreenSection} from "../../components/screen.js";
import {TypeArea} from "../../components/layout.js";
import {getFlashMessageCode} from "../store.js";

import "./flash_message.scss";

function FlashMessage({flashMessage}) {
  return flashMessage
    ? (
      <div className="flash-message">
        <p className="flash-message__text">{flashMessage}</p>
      </div>
    )
    : null;
};
FlashMessage.propTypes = {
  flashMessage: PropTypes.string
};

export default function ScreenFlashMessage() {
  const {translate} = useTranslation();
  
  const flashMessageCode = useSelector((state) => getFlashMessageCode(state));
  
  const flashMessage = useMemo(() => translate(flashMessageCode), [flashMessageCode, translate]);

  return flashMessageCode
    ? (
      <ScreenSection className="screen-flash-message" dark>
        <TypeArea>
          <FlashMessage flashMessage={flashMessage} />
        </TypeArea>
      </ScreenSection>
    )
    : null;
}
